import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { editAddress } from 'shared/components/userAddresses/actions';
import { toggleGift } from 'components/checkoutPage/actions';
import Summary from './Summary';
import Title from './Title';
import Icon from './Icon';

class Collapsed extends React.Component {
  componentDidUpdate() {
    const { isGift, giftRecipient, giftMobile, expand } = this.props;
    if (isGift && (_.isEmpty(giftRecipient) || _.isEmpty(giftMobile))) {
      expand();
    }
  }

  addDeliveryNotes() {
    this.props.expand();
    this.props.editAddress({ ...this.props.address });
  }

  render() {
    const { isGift, toggleGift, giftRecipient, giftNote, address } = this.props;

    return _.isEmpty(address) ? (
      <>
        <Icon />
        <Title />
      </>
    ) : (
      <Summary
        isGift={isGift}
        toggleGift={toggleGift}
        giftRecipient={giftRecipient}
        giftNote={giftNote}
        address={address}
        addDeliveryNotes={() => this.addDeliveryNotes()}
      />
    );
  }
}

const ConnectedCollapsed = connect(
  state => ({
    address: state.address,
    isGift: state.checkout.isGift,
    giftRecipient: state.checkout.giftRecipient,
    giftMobile: state.checkout.giftMobile,
    giftNote: state.checkout.giftNote
  }),
  {
    toggleGift,
    editAddress
  }
)(Collapsed);

export default ConnectedCollapsed;
